import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'

export interface AvailableSurveyApiItem {
  instrumentId: string
  campaignId: string
  name: string
  description: string | null
  estimatedCompletionMinutes: number
  questionCount: number
  reward: {
    enabled: boolean
    amount: number | null
    display: string | null
  }
  availableSlots: number
  instrumentStatus: 'fresh' | 'resume'
  lastAnsweredQuestionId: string | null
  hasActiveSession: boolean
  activeResponseId: string | null
}

export function useAvailableSurveys() {
  return useQuery({
    queryKey: queryKeys.spInstrument.availableList(),
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<AvailableSurveyApiItem[]>>(
        '/api/v1/sp/instruments',
      )
      return data.data ?? []
    },
  })
}
